import {AddPayeeComponent} from './add-payee/add-payee.component';
import { AdhaarUpdateComponent } from "./adhaar-update/adhaar-update.component";
import { AtmCardRequestComponent } from "./atm-card-request/atm-card-request.component";
import { AtmcardblockComponent } from "./atmcardblock/atmcardblock.component";
import {BranchToBranchTransferComponent} from "./branch-to-branch-transfer/branch-to-branch-transfer.component";
import { ChequeBookRequestComponent } from "./cheque-book-request/cheque-book-request.component";
import { ChequeStatusRequestComponent } from "./cheque-status-request/cheque-status-request.component";
import { ChequeStopRequestComponent } from "./cheque-stop-request/cheque-stop-request.component";
import { CustomerActivityComponent } from "./customer-activity/customer-activity.component";
import {DemoComponent} from './demo/demo.component';
import { FixedDepositeComponent } from "./fixed-deposite/fixed-deposite.component";
import {ForgotPasswordSuccessComponent} from './forgot-password-success/forgot-password-success.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {HomeComponent} from './home/home.component';
import {AuthguardService} from './service/authguard.service';
import {RegisterComponent} from './register/index';

import {ForgotUserIdComponent} from './forgot-user-id/forgot-user-id.component';
import {ForgotUseridSuccessComponent} from './forgot-userid-success/forgot-userid-success.component';
import {ImpsTransferComponent} from "./imps-transfer/imps-transfer.component";
import {ShowSuccessComponent} from './show-success/show-success.component';
//import {ComponentsComponent} from './layout/components/components.component';
import {DashboardComponent} from './layout/dashboard/dashboard.component';

import {LayoutComponent} from './layout/layout.component';
import {LoanAccountComponent} from './loan-account/loan-account.component';
import {ModifyOrDeletePayeeComponent} from './modify-or-delete-payee/modify-or-delete-payee.component';
import {TdAccountComponent} from './td-account/td-account.component';
import {MiniStatmentOfAccountComponent} from './mini-statment-of-account/mini-statment-of-account.component';
import {LoanStatmentOfAccountComponent} from './loan-statment-of-account/loan-statment-of-account.component';
import {NeftComponent} from "./neft/neft.component";
import { NewUserByBankComponent } from "./new-user-by-bank/new-user-by-bank.component";
import {OwnAccountTransferComponent} from "./own-account-transfer/own-account-transfer.component";
import {QuickTransferComponent} from "./quick-transfer/quick-transfer.component";
import {RtgsNeftTransferComponent} from "./rtgs-neft-transfer/rtgs-neft-transfer.component";
import { SocialSecurityComponent } from "./social-security/social-security.component";
import { StandingInstructionComponent } from "./standing-instruction/standing-instruction.component";
import {TdStatmentOfAccountComponent} from './td-statment-of-account/td-statment-of-account.component';
import {StatmentOfAccountComponent} from './statment-of-account/statment-of-account.component';
import { UpdateEmailComponent } from "./update-email/update-email.component";
import { UpdateMobileComponent } from "./update-mobile/update-mobile.component";
import {ErrorComponent} from "./error/error.component";
import {DisclaimerComponent} from "./disclaimer/disclaimer.component";
import {TermsConditionsComponent} from "./terms-conditions/terms-conditions.component";
import {PrivacyComponent} from "./privacy/privacy.component";
import {SecurityComponent} from "./security/security.component";
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FixedDepositComponent } from './fixed-deposit/fixed-deposit.component';
import { LoanIntCertificateComponent } from './loan-int-certificate/loan-int-certificate.component';
import { TdIntCertificateComponent } from './td-int-certificate/td-int-certificate.component';
import { ChangePasswordAfterExpireComponent } from './change-password-after-expire/change-password-after-expire.component';
import { LoanAccountDetailsComponent } from './loan-account-details/loan-account-details.component';
import { LoanDisburseDetailsComponent } from './loan-disburse-details/loan-disburse-details.component';
import { CardMenuComponent } from './card-menu/card-menu.component';
import { PositivepaystatusComponent } from './positivepaystatus/positivepaystatus.component';
import { PositivepayComponent } from './positivepay/positivepay.component';
//import { MyAccountsComponent } from './my-accounts/my-accounts.component';
import { InwardChequeComponent } from './inward-cheque/inward-cheque.component';
import { JonitAccHolderComponent } from './jonit-acc-holder/jonit-acc-holder.component';
import { ImpsMenuComponent } from './imps-menu/imps-menu.component';
import { UpiMenuComponent } from './upi-menu/upi-menu.component';
const routes: Routes = [

  {path: 'login', component: LoginComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'forgotuser', component: ForgotUserIdComponent},
  {path: 'forgotuserSuccess', component: ForgotUseridSuccessComponent},
  {path: 'forgotpassword', component: ForgotPasswordComponent},
  {path: 'forgotpwdsuccess', component: ForgotPasswordSuccessComponent},
  {path: 'new-user-by-bank', component: NewUserByBankComponent},
  { path: 'show-success', component:ShowSuccessComponent },
  { path: 'error', component:ErrorComponent },
  { path: 'Disclaimer', component:DisclaimerComponent },
  { path: 'TermsConditions', component:TermsConditionsComponent },
  { path: 'Privacy', component:PrivacyComponent },
  { path: 'Security', component:SecurityComponent },
 { path: 'change-password-after-expire', component:ChangePasswordAfterExpireComponent },


  {
    path: '', component: LayoutComponent, children: [
      {path: 'dashboard', component: DashboardComponent,},
      {path: 'demo', component: DemoComponent},
      {path: 'add-payee', component: AddPayeeComponent},
      {path: 'modify-or-delete-payee', component: ModifyOrDeletePayeeComponent},
      {path: 'td-account', component: TdAccountComponent},
      {path: 'loan-account', component: LoanAccountComponent},
      {path: 'mini-statment-of-account', component: MiniStatmentOfAccountComponent},
      {path: 'loan-statment-of-account', component: LoanStatmentOfAccountComponent},
      {path: 'td-statment-of-account', component: TdStatmentOfAccountComponent},
      {path: 'statment-of-account', component: StatmentOfAccountComponent},
      {path: 'branch-tobranch-transfer', component: BranchToBranchTransferComponent},
      {path: 'own-account-transfer', component: OwnAccountTransferComponent},
      {path: 'quick-transfer', component: QuickTransferComponent},
      {path: 'rtgs-neft-transfer', component: RtgsNeftTransferComponent},
      {path: 'neft', component: NeftComponent},
      {path: 'imps-transfer', component: ImpsTransferComponent},
      {path: 'adhaar-update', component: AdhaarUpdateComponent},
      {path: 'customer-activity', component: CustomerActivityComponent},
      {path: 'social-security', component: SocialSecurityComponent},
      {path: 'cheque-book-request', component: ChequeBookRequestComponent},
      {path: 'cheque-status-request', component: ChequeStatusRequestComponent},
      {path: 'cheque-stop-request', component: ChequeStopRequestComponent},
      {path: 'atmcardblock', component: AtmcardblockComponent},
      {path: 'atm-card-request', component: AtmCardRequestComponent},
      {path: 'standing-instruction', component: StandingInstructionComponent},
        {path: 'update-mobile', component: UpdateMobileComponent},
        {path: 'update-email', component: UpdateEmailComponent},
        {path: 'update-email', component: FixedDepositeComponent},
        {path: 'change-password', component:ChangePasswordComponent },
          {path: 'fixed-deposit', component:FixedDepositComponent },
        { path: 'ChangePassword', component:ChangePasswordComponent },
      { path: 'LoanIntCertificateComponent', component:LoanIntCertificateComponent},
      { path: 'TdIntCertificate', component:TdIntCertificateComponent },
	   { path: 'LoanAccountDetails', component:LoanAccountDetailsComponent},
      { path: 'LoanDisburseDetails', component:LoanDisburseDetailsComponent},
      { path: 'cardMenu', component:CardMenuComponent},
      { path: 'positive-pay', component:PositivepayComponent },
      { path: 'positive-pay-status', component:PositivepaystatusComponent },
      { path: 'inward-cheque', component:InwardChequeComponent },
      { path: 'joint-account', component:JonitAccHolderComponent },
      { path: 'impsMenu', component:ImpsMenuComponent},
      { path: 'upi-menu', component:UpiMenuComponent},
      //{ path: 'my-Account', component:MyAccountsComponent},

    ]
  }

  ,

  {
    path: 'index1', component: HomeComponent, canActivate: [AuthguardService],
    children: [

      //{ path: 'listitem', component: ListitemComponent, canActivate: [AuthguardService] },

      //{ path: '', redirectTo: '/login', pathMatch: 'full' },

    ]
  },

  // otherwise redirect to home
  {path: '**', redirectTo: '/login'}
];





export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/app.routing.ts